<div class="container text-primary" *transloco="let t">

  <div class="row">

    <div class="col my-4">
      <h1 class="fg-dark-purple mb-2">{{ t('guest.faq.title') }}</h1>

      <app-accordion [multiple]="true" [border]="true">
        <app-accordion-item
          [title]="t('guest.faq.WhoCanPublish.title')">
          <p>{{ t('guest.faq.WhoCanPublish.content') }}</p>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.GeographicScope.title')">
          <p>{{ t('guest.faq.GeographicScope.content') }}</p>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.PublishCost.title')">
          <p>{{ t('guest.faq.PublishCost.content') }}</p>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.WhatCanBePublished.title')">
          <p>{{ t('guest.faq.WhatCanBePublished.content') }}</p>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.WhatIsPhare.title')">
          <p>{{ t('guest.faq.WhatIsPhare.content') }}</p>
          <ul>
            <li><a href="doc/20241025-statuts-phare.pdf" target="_blank">{{ t('guest.faq.WhatIsPhare.status') }}</a></li>
            <li><a href="doc/20241025-assemblee-constitutive.pdf" target="_blank">{{ t('guest.faq.WhatIsPhare.assembly') }}</a></li>
          </ul>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.UpToDateWarranty.title')">
          <p>{{ t('guest.faq.UpToDateWarranty.content') }}</p>
          <ul>
            <li>{{ t('guest.faq.UpToDateWarranty.mec1') }}</li>
            <li>{{ t('guest.faq.UpToDateWarranty.mec2') }}</li>
            <li>{{ t('guest.faq.UpToDateWarranty.mec3') }}</li>
            <li>{{ t('guest.faq.UpToDateWarranty.mec4') }}</li>
          </ul>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.UnwantedData.title')">
          <p>{{ t('guest.faq.UnwantedData.content') }}</p>
          <ul>
            <li>{{ t('guest.faq.UnwantedData.mec1') }}</li>
            <li>{{ t('guest.faq.UnwantedData.mec2') }}</li>
            <li>
              {{ t('guest.faq.UnwantedData.mec3') }}
              <a [routerLink]="routes.contact">{{ t('guest.faq.UnwantedData.contactUs') }}</a>
            </li>
          </ul>
        </app-accordion-item>
        <app-accordion-item
          [title]="t('guest.faq.DataLocation.title')">
          <p>{{ t('guest.faq.DataLocation.content') }}</p>
          <!--        <p class="mt-2">-->
          <!--          <a href="https://www.swissmadesoftware.org/en/about/swiss-hosting.html" target="_blank">-->
          <!--            <img width="200" src="/img/sms-sh-logo.svg" alt="Swiss hosting"/>-->
          <!--          </a>-->
          <!--        </p>-->
        </app-accordion-item>
      </app-accordion>
    </div>
  </div>

</div>

